export default "__VITE_ASSET__5FAoLaVX__"